<template>
  <div class="container_box">
    <Tabs v-model="pageParams.status" :animated="false" class="tabs_styles" @on-click="search()">
      <TabPane v-for="item in statusList" :label="item.title" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '110px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId"
                  :value="item.ymsWarehouseId">{{ item.name }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004094')" prop="storageType">
              <Select v-model.trim="pageParams.storageType" filterable>
                <Option v-for="(item, index) in storageTypeList" :value="item.value" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004122')" prop="abnormalStatus">
              <Select v-model.trim="pageParams.abnormalStatus" filterable>
                <Option v-for="(item, index) in abnormalStatusList" :value="item.value" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001579')" prop="carrierIds">
              <Select v-model="pageParams.carrierIds" multiple filterable>
                <Option v-for="(item, index) in useLogisticsList" :value="item.carrierId" :key="index">{{ item.carrierName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                :options="dateOptions"
                @on-clear="resetDate('created')"
                @on-change=" (value)=> getDateValue(value, 'created')"
                :clearable="true"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="createTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004123')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                :options="dateOptions"
                @on-clear="resetDate('collection')"
                @on-change=" (value)=> getDateValue(value, 'collection')"
                :clearable="true"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="collectionTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001575')" prop="deliveryTypes">
              <Select v-model="pageParams.deliveryTypes" multiple :placeholder="$t('key1000110')">
                <Option v-for="(item, index) in deliveryTypesList" :value="item.value"
                  :key="index">{{ item.name }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--新建提单-->
      <Button type="primary" class="mr15" v-if="getPermission('ymsPickupOrder_createYmsPickupOrder')"
        @click="$refs['newBillOfLading'].initNewBillOfLadingData()">{{ $t('key1004093') }}</Button>
      <!--批量标记已揽收-->
      <Button type="primary" class="mr15" @click="batchMarking"
        v-if="getPermission('ymsPickupOrder_batchDelivery')">{{ $t('key1004125') }}
      </Button>
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsPickupOrder_orderListExport')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="460"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="getSelectValue"
        @on-sort-change="sortChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--货品上架弹窗-->
    <groundingModal ref="grounding" :warehouseList="ymsWarehouseList" @updateData="getList()"></groundingModal>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1004124')"
      paramKeyColums="ymsPickupOrderExportColumns"
      :customFieldExportList="customFieldExportList"
      :dimensionTypeList="dimensionTypeList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--提单SKU详情弹窗-->
    <billSkuDetailsModal ref="billSkuDetails"></billSkuDetailsModal>
    <!--修改物流信息弹窗-->
    <logisticsInfoModal ref="logisticsInfo" @updateData="pageParamsStatus = true"></logisticsInfoModal>
    <!--作废提单确认弹窗-->
    <voidBillModal ref="voidBill" @updateData="pageParamsStatus = true"></voidBillModal>
    <!--新建提单弹窗-->
    <newBillOfLadingModal ref="newBillOfLading" @updateData="pageParamsStatus = true"></newBillOfLadingModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import dropDownFilter from "@/components/common/dropDownFilter";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import groundingModal from "@/views/yms/components/collectionManage/groundingModal";
import billSkuDetailsModal from "@/views/yms/components/collectionManage/billSkuDetailsModal";
import logisticsInfoModal from "@/components/common/logisticsInfoModal.vue";
import voidBillModal from "@/views/yms/components/collectionManage/voidBillModal";
import newBillOfLadingModal from "@/views/yms/components/collectionManage/newBillOfLadingModal.vue";
import {
  jumpToTheCourierInquiry, pageJump, setConfigCharacters, getEnableWarehouseData,
  getWarehouseName, getEnumName, getDataSetBatchList, getEnumList, commonLocalStorage
} from "@/utils/common";

export default {
  name: 'billLadingManage',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      selectTableData: [],
      createTime: [],
      collectionTime: [],
      statusList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004102')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003694')},
        {value: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004103')},
        {value: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003695')},
        {value: 99, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003696')},
      ],
      abnormalStatusList: [
        {value: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004104')}
      ],
      pageParams: {
        status: null,
        abnormalStatus: 'null',
        ymsPickupOrderNumbers: '',
        createdStartTime: null,
        createdEndTime: null,
        pickupStartTime: null,
        pickupEndTime: null,
        ymsWarehouseId: 'null',
        expressageNos: '',
        supplierMerchantIds: '',
        thirdPickupOrderNumbers: '',
        deliveryTypes: [],
        skus: '',
        upDown: 'down',
        orderBy: 'createdTime',
        carrierIds: [],
        storageType: 'null',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775'),
          key: 'supplierPickupOrderNumber',
          minWidth: 160,
          fixed: 'left',
          align: 'center',
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.supplierPickupOrderNumber,
                styles: {
                  justifyContent: 'center'
                }
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/billLadingManageDetails',
                    query: {
                      ymsPickupOrderId: params.row.ymsPickupOrderId
                    }
                  });
                  window.open(href, '_blank');
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'),
          key: 'thirdPickupOrderNumber',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let thirdPickupOrderNumber = params.row.thirdPickupOrderNumber || '-';
            return h('span', thirdPickupOrderNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004105'),
          key: 'storageType',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let storageType = params.row.storageType;
            let name = getEnumName(v.enumData, 'StorageTypeCoreEnum', storageType, 'number');
            return h('span', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let statusTxt = '-';
            let status = params.row.status === 21 ? 3 : params.row.status;
            let content = params.row.invalidReason;
            v.statusList.map((item) => {
              if (item.value === status) {
                statusTxt = item.title;
              }
            });
            return h('div', {class: 'flex align-items-center'}, [
              h('span', statusTxt),
              status === 99 ? h('Tooltip', {
                props: {
                  transfer: true,
                  content: content,
                  maxWidth: 300,
                  placement: 'top'
                }
              }, [
                h('Icon', {
                  class: 'ml3 cursor',
                  props: {
                    type: 'md-help-circle',
                    size: 17,
                    color: '#7F7F7F'
                  },
                })
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003867'),
          key: 'deliveryMethod',
          align: 'center',
          minWidth: 170,
          render(h, params) {
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let text = '-';
            if (deliveryType === 1) {
              let name = getEnumName(v.enumData, 'TransportTypeEnum', transportType, 'number');
              text = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}` + ' ' + '-' + ' ' + name;
            } else if (deliveryType === 2) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587');
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220'),
          key: 'carrierName',
          align: 'center', // YMS上门揽收
          minWidth: 160,
          render(h, params) {
            let carrierName = params.row.carrierName || '-';
            let deliveryType = params.row.deliveryType;
            let transportType = params.row.transportType;
            let text = '-';
            if (deliveryType === 1 && transportType === 2) {
              text = `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`;
            } else {
              if (transportType === 1 && deliveryType === 1) {
                text = carrierName;
              } else {
                if (v.useLogisticsList.length > 0) {
                  v.useLogisticsList.map((item) => {
                    if (item.carrierId === carrierName) {
                      text = item.carrierName;
                    }
                  });
                }
              }
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571'),
          key: 'logisticsInfo',
          align: 'center',
          minWidth: 230,
          render(h, params) {
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let expressageNo = params.row.expressageNo;
            let expressageCode = params.row.expressageCode;
            let trackingNumber = params.row.trackingNumber;
            /*
            * deliveryType=1且transport_type=1 物流信息显示trackingNumber
              deliveryType=1且transport_type=2 物流信息显示“YMS上门揽收”这几个字
              deliveryType=2 物流信息显示expressageNo，并把expressageCode传给快递100
            * */
            return h('div', [
              deliveryType === 1 && transportType === 2 ? h('span', `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`) :
                h('div', [
                  h('Alink', {
                    props: {
                      linkName: deliveryType === 2 ? expressageNo : trackingNumber,
                      Aicon: '&#xe6e7;',
                      AlinkShow: false,
                      AiconSize: '22px',
                      AiconShow: !!(trackingNumber || expressageNo),
                      AiconColor: '#2D8CF0',
                      styles: {
                        justifyContent: 'center'
                      }
                    },
                    on: {
                      AIconBtn: () => {
                        jumpToTheCourierInquiry(expressageCode, expressageNo, trackingNumber);
                      }
                    }
                  })
                ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003841'),
          key: 'logisticsCostCurrency',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let logisticsCostCurrency = params.row.logisticsCostCurrency;
            let logisticsCost = params.row.logisticsCost;
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let text = '-';
            if (deliveryType === 1 && transportType === 1) {
              if (logisticsCost && logisticsCostCurrency) {
                text = logisticsCost + ' ' + logisticsCostCurrency;
              }
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675'),
          key: 'subsidyAmount',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let subsidyAmount = params.row.subsidyAmount;
            return subsidyAmount ? h('span', subsidyAmount + ' ' + v.currencyState) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004106'),
          key: 'trackingMessage',
          align: 'center',
          minWidth: 160,
          render(h, params) {
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            let transportType = params.row.transportType; // 运输方式{1快递 2上门揽收}
            let trackingMessage = '-';
            if (deliveryType === 1 && transportType === 1) {
              trackingMessage = params.row.trackingMessage || '-';
            }
            return h('span', trackingMessage);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 140,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004107'),
          key: 'totalQuantities',
          minWidth: 130,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004108'),
          key: 'totalActualSortingNumber',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let totalQuantities = params.row.totalQuantities;
            let totalActualSortingNumber = params.row.totalActualSortingNumber;
            let talg = false;
            if (totalQuantities && totalActualSortingNumber && totalActualSortingNumber !== totalQuantities) {
              talg = true;
            }
            return h('span', {class: talg ? 'redColor' : ''}, totalActualSortingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004109'),
          key: 'totalSupplierOverSortingNumber',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let totalSupplierOverSortingNumber = params.row.totalSupplierOverSortingNumber || '-';
            return h('span', {class: totalSupplierOverSortingNumber !== '-' ? 'redColor' : ''}, totalSupplierOverSortingNumber);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110'),
          key: 'abnormalStatus',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let text = '-';
            let talg = false;
            let hasStockPackage = params.row.hasStockPackage; // 是否有多发补单 0 无 1 有
            let status = params.row.status;
            let skuTotal = params.row.skuTotal;
            let totalActualSortingNumber = params.row.totalActualSortingNumber || 0;
            let totalQuantities = params.row.totalQuantities;

            if ((skuTotal > 0 && skuTotal !== totalActualSortingNumber) ||
              hasStockPackage === 1 || (totalActualSortingNumber !== totalQuantities)) {
              text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004111');
              talg = true;
            }
            return status === 4 ? h('Alink', {
              props: {
                linkName: text,
                AlinkShow: talg,
                defineColor: talg ? '#FF3300' : '',
                styles: {
                  justifyContent: 'center'
                }
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/billLadingManageDetails',
                    query: {
                      ymsPickupOrderId: params.row.ymsPickupOrderId
                    }
                  });
                  window.open(href, '_blank');
                }
              }
            }) : h('span', '-');
          }
        },
        {
          title: 'SKU',
          key: 'skus',
          minWidth: 220,
          sortable: true,
          align: 'center',
          render(h, params) {
            let skus = params.row.skus || [];
            let list = [];
            if (skus.length > 0) {
              let arr = skus.slice(0, 2) || [];
              arr.map((item) => {
                list.push(h('div', item));
              });
              if (skus.length > 2) {
                list.push(
                  h('Alink', {
                    props: {
                      linkName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000022'),
                    },
                    on: {
                      AlinkBtn: () => {
                        v.$refs['billSkuDetails'].initBillSkuDetailsData(params.row);
                      }
                    }
                  })
                );
              }
              return h('div', {
                class: 'flex flex-direction justify-content-center align-items-center'
              }, list);
            } else {
              return h('span', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          sortType: 'desc',
          render(h, params) {
            return h('span', params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003660'),
          key: 'pickupTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            return h('span', params.row.pickupTime ? v.$uDate.dealTime(params.row.pickupTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846'),
          key: 'storageTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            return h('span', params.row.storageTime ? v.$uDate.dealTime(params.row.storageTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003847'),
          key: 'pickingEndTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          render(h, params) {
            return h('span', params.row.pickingEndTime ? v.$uDate.dealTime(params.row.pickingEndTime, 'fulltime') : '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002365'),
          key: 'shippingAddress',
          minWidth: 220,
          align: 'center',
          render(h, params) {
            let text = '-';
            let obj = params.row;
            let list = [];
            let keyList = ['senderName', 'senderPhone', 'senderCountryCode', 'senderState', 'senderCity', 'senderDistrict', 'senderAddress'];
            keyList.map((key) => {
              if (obj[key]) {
                list.push(obj[key]);
              }
            });
            text = list.join('，');
            return h('div', {
              class: 'ellipsis_2',
              attrs: {
                title: text
              },
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          align: 'center',
          key: 'remark',
          width: 300,
          render: (h, params) => {
            return v.checkContentOverflow(h, params.row.remark, 300, 1)
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'opts',
          align: 'center',
          width: 200,
          fixed: 'right',
          render(h, params) {
            let ymsPickupOrderId = params.row.ymsPickupOrderId;
            let status = params.row.status;
            let deliveryType = params.row.deliveryType; // 发货方式{1YMS物流 2自有物流}
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsPickupOrder_detail'),
                    clickFn: () => {
                      const {href} = v.$router.resolve({
                        path: '/billLadingManageDetails',
                        query: {
                          ymsPickupOrderId: ymsPickupOrderId
                        }
                      });
                      window.open(href, '_blank');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004112'),
                    show: status === 1 && v.getPermission('ymsPickupOrder_delivery'),
                    clickFn: () => {
                      v.markAccepted(ymsPickupOrderId);
                    }
                  },
                  // YMS-10324 需求调整先屏蔽掉， 统一走分拣上架
                  /*{
                    text: '货品上架',  // 只有是否需要上架值为1，并且状态为已入库状态才显示上架按钮, 是否已上架: needshelfed
                    show: status === 21 && params.row.needshelfed === '1' && v.getPermission('ymsPickupOrder_onShelves'),
                    clickFn: () => {
                      v.$refs['grounding'].getGroundingDetails(params.row.ymsPickupOrderId, params.row.supplierPickupOrderNumber);
                    }
                  },*/
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001573'),
                    show: status === 1 && deliveryType === 2,  // 等待揽收且是自有物流才显示修改物流信息按钮
                    clickFn: () => {
                      v.$refs['logisticsInfo'].initLogisticsInfo(ymsPickupOrderId, 'billLadingManage');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004113'),
                    show: status === 1,
                    clickFn: () => {

                      v.$refs['voidBill'].initVoidBillData(ymsPickupOrderId);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      warehouseList: [],
      ymsWarehouseList: [],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001775'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003849'), parameterKey: 'ymsPickupOrderNumbers'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003850'), parameterKey: 'expressageNos'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003851'), parameterKey: 'supplierMerchantIds'},
        {title: 'SKU', value: 4, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004114'), parameterKey: 'skus'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047'), value: 5, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004115'), parameterKey: 'thirdPickupOrderNumbers'},
      ],
      defaultSelectValue: 1,
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2], paramKey: 'supplierPickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004116')},
            {type: [1, 2], paramKey: 'thirdPickupOrderNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004047')},
            {type: [1, 2], paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {type: [1, 2], paramKey: 'supplierMerchantName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004117')},
            {type: [1, 2], paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461')},
            {type: [1, 2], paramKey: 'abnormalStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004110')},
            {type: [1, 2], paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159')},
            {type: [1, 2], paramKey: 'pickupTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003660')},
            {type: [1, 2], paramKey: 'expressageNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004118')},
            {type: [1, 2], paramKey: 'expressageName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004119')},
            {type: [1, 2], paramKey: 'storageType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004105')},
            {type: [1, 2], paramKey: 'remark', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350')},
            {type: [1], paramKey: 'skuTotal', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004107')},
            {type: [1], paramKey: 'totalActualSortingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004108')},
            {type: [1], paramKey: 'totalSupplierOverSortingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004109')},
            {type: [1], paramKey: 'deliveryType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003867')},
            {type: [1], paramKey: 'logisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003841')},
            {type: [1], paramKey: 'logisticsMessage', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571')},
            {type: [1], paramKey: 'subsidyAmount', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003675')}`},
            {type: [1], paramKey: 'trackingMessage', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004106')},
            {type: [1], paramKey: 'warehouseId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390')},
            {type: [1], paramKey: 'storageTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003846')},
            {type: [1], paramKey: 'pickingEndTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003847')},
            {type: [1], paramKey: 'address', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002365')},
            {type: [2], paramKey: 'ymsSku', paramValue: 'SKU'},
            {type: [2], paramKey: 'skuQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695')},
            {type: [1, 2], paramKey: 'carrierName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220')},
          ]
        }
      ],
      dimensionTypeList: [
        {value: 1, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004120')},
        {value: 2, show: true, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004060')}
      ],
      deliveryTypesList: [
        {value: 1, name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003859')}`},
        {value: 2, name: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003860')}`},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587')},
      ],
      useLogisticsList: [],
      enumData: []
    };
  },
  computed: {
    filterKeyList() {
      return this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
    },
    // 平台自营商品模式配置
    platformSelfOperatedProduct() {
      let saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.platformSelfOperatedProductModelSaas) === 1;
    },
    // 入库类型
    storageTypeList() {
      const ENUM_KEY = 'StorageTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      if (this.platformSelfOperatedProduct) {
        return list;
      } else {
        return list.filter(item => item.value !== 3);
      }
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.setDefaultTimerParams('three_months', '', 'created');
      v.warehouseList = [];
      (async () => {
        let enumKeyList = ['TransportTypeEnum', 'StorageTypeCoreEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getEnableWarehouseData(1).then((data) => {
          v.ymsWarehouseList = JSON.parse(JSON.stringify(data));
          v.warehouseList = JSON.parse(JSON.stringify(data));
          v.warehouseList.unshift({
            ymsWarehouseId: 'null',
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
          });
        });
        await v.getUseLogistics();
        await v.getList();
      })();
    },
    // 获取使用过的物流商数据
    getUseLogistics() {
      this.useLogisticsList = [];
      this.axios.get(api.get_expressageHundred_query + '?type=kuaidi100').then(response => {
        if (response.data.code === 0) {
          let typeShippingList = response.data.datas || [];
          if (typeShippingList.length > 0) {
            this.axios.get(api.get_ymsPickupOrder_queryLogistics).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || [];
                if (data.length > 0) {
                  data.map((item) => {
                    typeShippingList.map((ele) => {
                      if (item.carrierId === ele.code) {
                        item.carrierName = ele.name;
                      }
                    });
                  });
                  this.useLogisticsList = data;
                  this.useLogisticsList.unshift({carrierId: "ymspickcollec", carrierName: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001582')}`});
                }
              }
            });
          }
        }
      });
    },
    // 获取日期返回值
    getDateValue(value, type) {
      let v = this;
      if (value.length === 0 || !value[0]) {
        v.resetDate(type);
      } else {
        if (value[0] !== '') {
          let timeList = v.defaultTimePeriod(value);
          // 创建时间
          if (type === 'created') {
            v.createTime = v.defaultTimePeriod(value, false);
            v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
            v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
          }
          // 揽收时间
          else if (type === 'collection') {
            v.collectionTime = value;
            v.pageParams.pickupStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
            v.pageParams.pickupEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
          }
        }
      }
    },
    // 重置创建时间
    resetDate(type) {
      if (type === 'created') {
        this.createTime = [];
        this.pageParams.createdStartTime = null;
        this.pageParams.createdEndTime = null;
      }
      if (type === 'collection') {
        this.collectionTime = [];
        this.pageParams.pickupStartTime = null;
        this.pageParams.pickupEndTime = null;
      }
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let nullKeyList = ['ymsWarehouseId', 'status', 'storageType'];
      for (let key of nullKeyList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      if (v.getPermission('ymsPickupOrder_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsPickupOrder_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.$refs['selection'].selectAll(false);
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.updateTableDom('selection');
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.createTime = [];
      v.collectionTime = [];
      v.resetDate('created');
      v.resetDate('collection');
      v.changeInput(1);
      v.setDefaultTimerParams('three_months', '', 'created');
      v.getList();
    },
    // 获取列表勾选的数据
    getSelectValue(value) {
      this.selectTableData = value;
    },
    // 批量标记已揽收
    batchMarking() {
      let v = this;
      let ymsPickupOrderIds = [];
      if (v.selectTableData.length > 0) {
        v.selectTableData.map((item) => {
          ymsPickupOrderIds.push(item.ymsPickupOrderId);
        });
        v.axios.put(api.put_ymsPickupOrder_batchDelivery, ymsPickupOrderIds, {
          loading: true,
          loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
        }).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
            v.pageParamsStatus = true;
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004121'));
        return false;
      }
    },
    // 单个标记已揽收
    markAccepted(ymsPickupOrderId) {
      let v = this;
      v.axios.put(api.put_ymsPickupOrder_delivery + `${ymsPickupOrderId}`, null, {
        loading: true,
        loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
      }).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.supplierPickupOrderNumberList = v.selectTableData.map((item) => {
          return item.supplierPickupOrderNumber;
        });
      } else {
        query.supplierPickupOrderNumberList = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          query.exportColumsNameIndexBo = {
            businessId: data.businessId,
            paramKeys: [data.paramKey]
          };
          query.exportType = obj.dimensionType;
          v.axios.post(api.post_ymsPickupOrder_orderListExport, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    dropDownFilter,
    exportFieldsModal,
    groundingModal,
    billSkuDetailsModal,
    logisticsInfoModal,
    voidBillModal,
    newBillOfLadingModal
  }
};
</script>

<style lang="less" scoped>
.tabs_styles {
  /deep/ .ivu-tabs-bar {
    border-bottom: none;
    background-color: #fff;
    padding: 8px 0 3px 0;
    margin: 0;
  }
}

.table_box /deep/ .link_box_style {
  a {
    width: inherit !important;
  }
}
</style>
